import React, { useState } from "react";
import "./input.css";
import { useTranslation } from "../../../Hooks/useTranslation";

const applyMask = (value, mask) => {
  if (!mask || !value) return value;
  const digits = String(value).replace(/\D/g, "");
  let result = "";
  let i = 0;
  for (const char of mask) {
    if (i >= digits.length) break;
    if (char === "9") result += digits[i++];
    else result += char;
  }
  return result;
};

const Input = ({
  label,
  labelColor,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  success,
  mask,
  variant,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const isPassword = variant === "Password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  const handleChange = (e) => {
    if (mask) e.target.value = applyMask(e.target.value, mask);
    if (onChange) onChange(e);
  };

  return (
    <div className={`casvi-input ${error ? "has-error" : ""} ${success ? "has-success" : ""}`}>
      {label && (
        <label htmlFor={name} style={labelColor ? { color: labelColor } : undefined}>
          {label}
        </label>
      )}
      <div className="casvi-input-field">
        <input
          id={name}
          name={name}
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
        />
        {isPassword && (
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? t.input.hide : t.input.show}
          </button>
        )}
      </div>
      {error && <span className="casvi-input-error">{error}</span>}
    </div>
  );
};

export default Input;
